module.exports = __webpack_public_path__ + "img/pdf_preview_bg.88037ab5.png";